import React from "react";
import { IConfirmCcaStudentRenewalButton } from "./ConfirmCcaStudentRenewalButton";
import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import CloseIcon from "@material-ui/icons/Close";

const DeclineButton = ({
  id,
  studentId,
  ccaAcademicYearId,
}: IConfirmCcaStudentRenewalButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleDeclineStudentRenewal, { loading }] = useMutation(
    {
      type: "update",
      resource: `ccaStudentRenewals`,
      payload: {
        id: id,
        data: {
          isAcceptCcaRenewal: false,
          studentId: studentId,
          ccaAcademicYearId: ccaAcademicYearId,
        },
      },
    },
    {
      onSuccess: () => {
        notify(`Successfully decline student renewal.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed accept decline renewal, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleDeclineStudentRenewal}
      color="primary"
      label={loading ? "Please wait..." : "Decline"}
      style={{ backgroundColor: "#f44336" }}
    >
      <CloseIcon />
    </Button>
  );
};

export default DeclineButton;
